'use strict';

module.exports = function(app) {

    app.notificationCountRefresh = function(form) {
        var count = $(form).find('.js-notification').length;
        var countBubble = $('.notification-list .bubble');

        if (count > 0) {
            countBubble.show().html(count);
        } else {
            countBubble.hide();
        }
    };

    return app;
};
